module.exports = __webpack_public_path__ + "static/img/IMG_2727.f353a60.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/9/IMG_2727.jpg
// module id = 786
// module chunks = 0